import React from "react";
import { Code2, Zap, Users } from "lucide-react";

export function FeaturesSection() {
  return (
    <div className="relative overflow-hidden bg-volt-carbon/50 py-24">
      <div className="absolute inset-0 bg-gradient-to-b from-volt-blue/5 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="inline-block text-3xl font-bold mb-4 bg-gradient-to-r from-volt-green via-volt-blue to-volt-green text-transparent bg-clip-text pb-2 border-b-2 border-volt-blue/20">
            Why Choose Block Pattern Generator?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto mt-4">
            Create professional WordPress layouts in minutes, not hours. Simply
            copy and paste our generated patterns into your WordPress site.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Feature cards with updated styling */}
          <div className="group bg-white/5 backdrop-blur-sm rounded-xl p-8 hover:bg-white/10 transition-all hover:translate-y-[-2px] hover:shadow-lg hover:shadow-volt-blue/5">
            <div className="bg-gradient-to-br from-volt-green/10 to-volt-blue/10 rounded-lg w-14 h-14 flex items-center justify-center mb-6">
              <Zap className="h-7 w-7 text-volt-green" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">
              AI-Powered Generation
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Describe your vision in plain English, and watch as our AI
              transforms it into beautiful WordPress blocks instantly. No coding
              required.
            </p>
          </div>

          <div className="group bg-white/5 backdrop-blur-sm rounded-xl p-8 hover:bg-white/10 transition-all hover:translate-y-[-2px] hover:shadow-lg hover:shadow-volt-blue/5">
            <div className="bg-gradient-to-br from-volt-blue/10 to-volt-green/10 rounded-lg w-14 h-14 flex items-center justify-center mb-6">
              <Code2 className="h-7 w-7 text-volt-blue" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">
              Copy & Paste Ready
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Every pattern is optimized for WordPress and works instantly. Just
              copy, paste into your site, and you're done.
            </p>
          </div>

          <div className="group bg-white/5 backdrop-blur-sm rounded-xl p-8 hover:bg-white/10 transition-all hover:translate-y-[-2px] hover:shadow-lg hover:shadow-volt-blue/5">
            <div className="bg-gradient-to-br from-volt-green/10 to-volt-blue/10 rounded-lg w-14 h-14 flex items-center justify-center mb-6">
              <Users className="h-7 w-7 text-volt-green" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">
              Professional Templates
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Start with our curated collection of professional templates and
              customize them to match your brand perfectly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
